import createModule from "../createModule"
import view from "./view"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators } from "./model"
import { getExperimentsUrl, getStatus, getIsOneDayExperiment, getSelectedExperiment, getExperimentId, getIndex, getPortfolioAlias, getAccount, getExperimentToSave, getSimulationConfig, getHasChanges, getSaveEnabled, getPortfolioUUID } from "./selectors"
import { getSelectedDate } from "./selectors/dates"
import { getViewType, getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"
import { getBasePositionSet, getBaseSignature } from "selectors/base"
import { VIEW_TYPES } from "helpers/base"
import withUrlParams from "hocs/withUrlParams"
import { FORECAST_LIST_QUERY } from "resources/forecasts"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: getAccount(state),
    portfolioAlias: getPortfolioAlias(state),
    portfolioUUID: getPortfolioUUID(state),
    experimentId: getExperimentId(props),
    experiment: getSelectedExperiment(state),
    selectedDate: getSelectedDate(state),
    base: getBasePositionSet(state),
    baseSignature: getBaseSignature(state),
    viewType: getViewType(state),
    modelId: getSelectedModelId(state),
  }),
  required: ["account", "portfolioAlias", "experimentId", "modelId"],
  data: [{
    resource: "experimentMeta",
    as: null,
    url: ({ account, experimentId }) => `/api/${account}/e/${experimentId}`,
  }, {
    ...FORECAST_LIST_QUERY,
    as: null,
  }, {
    resource: "experimentPositions",
    as: null,
    url: ({ modelId, portfolioAlias, experiment, selectedDate }) => {
      if (!experiment || experiment.type !== "SIMULATION") {
        return null
      }

      return {
        id: `experimentPositions-${modelId}${experiment.id}${portfolioAlias}${selectedDate}`,
        query: `query ($modelId: String!, $experimentId: String!, $date: Date!, $portfolioAlias: String!) {
          model(id:$modelId){
            simulation (positionSet:{type: PORTFOLIO id:$portfolioAlias experimentId: $experimentId} from:$date to:$date interval:POSITION_SET_DATES){
              composition{
                positions{
                  id
                  assetClass
                  modelProviderId
                  country
                  economicExposure
                }
              }
            }
          }
        }`,
        variables: {
          date: selectedDate,
          portfolioAlias,
          experimentId: experiment.id,
          modelId,
        },
      }
    },
  }, {
    resource: "portfolioPositions",
    as: null,
    url: ({ modelId, portfolioAlias, experiment, selectedDate, viewType, base, baseSignature }) => {
      if (!experiment || experiment.type !== "SIMULATION") {
        return null
      }

      baseSignature = viewType === VIEW_TYPES.ACTIVE ? baseSignature : ""
      base = viewType === VIEW_TYPES.ACTIVE ? base : null

      return {
        id: `portfolioPositions-${modelId}${portfolioAlias}${selectedDate}${baseSignature}`,
        query: `query ($date: Date!, $portfolioAlias: String!, $modelId: String!, $base: [PositionSetInput]) {
          model(id:$modelId){
            nonActive:simulation (positionSet:{type: PORTFOLIO id:$portfolioAlias} from:$date to:$date){
              composition{
                gmv
                referenceEquity
                positions{
                  id
                  assetClass
                  country
                  economicExposure
                  modelProviderId
                }
              }
            }
            active:simulation (positionSet:{type: PORTFOLIO id:$portfolioAlias} base:$base from:$date to:$date){
              composition{
                positions{
                  id
                  assetClass
                  country
                  economicExposure
                }
              }
            }
          }
        }`,
        variables: {
          date: selectedDate,
          portfolioAlias,
          modelId,
          base,
        },
      }
    },
  }],
  mapStateToProps: state => ({
    experimentsUrl: getExperimentsUrl(state),
    experimentToSave: getExperimentToSave(state),
    index: getIndex(state),
    rebalanceConfig: getSimulationConfig(state),
    hasChanges: getHasChanges(state),
    saveEnabled: getSaveEnabled(state),
    isOneDayExperiment: getIsOneDayExperiment(state),
    status: getStatus(state),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
}))
